export default "__VITE_ASSET__x_S5NPYP__"